import { CSPUrlsMap } from '../routes/CSPUrlsMap';

const cspMiddlewareApiIdentifier = 'https://cspmiddlewareapi';
const { origin, pathname, search } = window.location;
const redirectUri = `${origin}${CSPUrlsMap.verification.url}?redirect_to=${encodeURIComponent(pathname + search)}`;

export const nonSSOAuthorizationParams = {
  audience: cspMiddlewareApiIdentifier,
  scope:
    'openid profile email mfa enroll read:authenticators remove:authenticators write:token read:policy read:claim write:claim write:policy',
  responseType: 'code',
  connection: '',
  redirectUri
};

export const ssoAuthorizationParams = {
  audience: cspMiddlewareApiIdentifier,
  scope: 'openid profile email',
  responseType: 'code id_token token',
  connection: 'everyday-insurance-portal',
  redirectUri
};
